{
	"type": "fill",
	"minzoom": 8,
	"filter": [
		"match",
		["get", "lay_class"],
		[
			"Aboriginal Object",
			"Conservation Area - Archaeological",
			"Item - Aboriginal",
			"Item - Archaeological",
			"Item - General",
			"Item - Landscape",
			"Local Heritage - General",
			"Conservation Area - General",
			"Conservation Area - Landscape",
			"Heritage Conservation Area"
		],
		true,
		false
	],
	"layout": {},
	"paint": {
		"fill-color": [
			"match",
			["get", "lay_class"],
			"Aboriginal Object",
			"#ffc700",
			"Conservation Area - Archaeological",
			"#e4df17",
			"Item - Aboriginal",
			"#ffc700",
			"Item - Archaeological",
			"#ffffbf",
			"Item - General",
			"#dbbb7b",
			"Item - Landscape",
			"#b3e096",
			"Local Heritage - General",
			"#dbbb7b",
			"Conservation Area - General",
			"#e30000",
			["Conservation Area - Landscape", "Heritage Conservation Area"],
			"#046a00",
			"#ddd"
		],
		"fill-antialias": true,
		"fill-outline-color": "#000",
		"fill-opacity": [
			"match",
			["get", "lay_class"],
			[
				"Conservation Area - General",
				"Conservation Area - Landscape",
				"Heritage Conservation Area"
			],
			0.3,
			1
		]
	}
}
